export default "__VITE_ASSET__nbLu_P3e__"